import React from "react";
// import loading from "../../assets/images/loading.gif";

const Loading = () => {
  return (
    <div className="overlay">
      {/* <img src={loading} alt="" /> */}
    </div>
  );
};

export default Loading;
